{
    "dashboard": "Dashboard",
    "client": "Client",
    "roles": "Roles",
    "roleSummary": "Manage user roles and permissions",
    "comingSoon": "Coming soon...",
    "systems": "Systems",
    "attributes": "Attributes",
    "filters": "Filters",
    "tools": "Tools",
    "multiDatasource": "Multi Data Source",
    "multiDatasourceSummary": "Create and manage multi data source configurations",
    "reports": "Reports",
    "reportsSummary": "Print detailed specifications for the Attribute and Filter definitions",
    "import": "Import",
    "importSummary": "Import data from another ATB Client-System",
    "export": "Export",
    "exportSummary": "Export data for use within another ATB Client-System",
    "manage": "Manage",
    "manageSummary": "Bulk Management Operations for Attributes and Filters",
    "toolsHome": "Tools Home"
}